<!--suppress ALL -->
<template>
  <g-field :label="hasSlotDefault || skipLabel ? '' : 'Tahun masuk'"
           class="select-tahun-ajaran" :is-horizontal="hasSlotDefault">
    <label v-if="hasSlotDefault" class="label">{{$t('label.tahun')}}</label>
    <g-select :value="tahun" :placeholder="`Pilih tahun masuk`"
              :disabled="disabled" @change="onChange" v-bind="$attrs">
      <option v-for="th in tahuns" :key="th" :value="th">{{th}}</option>
    </g-select>
    <slot></slot>
  </g-field>
</template>

<script lang="ts">
	import {Component, Prop, Vue} from 'annotation';
	import {tahuns} from '../../../util/PluralVariabels';

	@Component
	export default class SelectTahun extends Vue {

		@Prop({type: String})
		public tahun: string;

		@Prop({type: Boolean, default: false})
		public disabled: boolean;

    @Prop({type: Boolean, default: false})
    public skipLabel: boolean;

		public tahuns: Array<any> = tahuns;

		public onChange(val) {
			this.$emit('update:tahun', val);
			this.$emit('tahun-selected', val);
		}

		public get hasSlotDefault() {
			return this.$scopedSlots.default || this.$slots.default;
		}
	}
</script>

<style lang="scss">
  .select-tahun-ajaran {
    .select, select {
      min-width: 200px;
      width: 100%;
    }
    &.is-horizontal {
      .field-body {
        align-items: center;
        .field {
          &:first-child {
            width: 150px;
          }
          flex: none;
        }
      }
    }
  }
</style>
